<style>
.prompt-textarea .form-control {
  font-size: 17px;
}

</style>
<template>
    <div>

        <CRow>
            <CCol lg="12">
                <CButton @click="$router.go(-1)" size="sm" color="warning">
                    <font-awesome-icon icon="arrow-left" /> Go back
                </CButton>
            </CCol>
        </CRow>
        <br>
        <CRow>
            <CCol :lg="isExpanded ? 12 : 7">
                <CCard :key="update_key">
                    <CCardHeader><font-awesome-icon icon="cog" /> Manage Document Template Prompt
                        <CButton 
                            color="primary" 
                            size="sm"
                            class="float-right"
                            style="margin-left: 5px;"
                            @click="isExpanded = !isExpanded"
                        >
                            <font-awesome-icon :icon="isExpanded ? 'compress' : 'expand'" /> 
                        </CButton>
                        <template v-if="template_prompt.status == 'Active'">
                            <CButton size="sm" color="danger" class="float-right"
                                @click="toggleEdit(), returnInformation()" v-show="edit">
                                <font-awesome-icon icon="window-close" /> Cancel
                            </CButton>
                            <CButton v-if="$store.getters['can']('update-document-template-prompt')" size="sm"
                                :disabled="!isValid" color="success" class="float-right" v-show="edit"
                                @click="updatePrompt()">
                                <font-awesome-icon icon="save" /> Update
                            </CButton>
                            <CButton v-if="$store.getters['can']('edit-document-template-prompt')" size="sm"
                                color="info" class="float-right" @click="toggleEdit" v-show="!edit">
                                <font-awesome-icon icon="edit" /> Edit
                            </CButton>
                        </template>
                        <template v-if="template_prompt.status == 'Archived'">
                            <CButton v-if="$store.getters['can']('restore-document-template-prompt')" size="sm"
                                color="success" class="float-right" @click="restore()">
                                <font-awesome-icon icon="trash-restore" /> Restore
                            </CButton>
                        </template>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol lg="6">
                                <CInput :lazy="false" label="Name" type="text" :disabled="!edit" autocomplete="off"
                                    v-tocapitalize v-model="template_prompt.name"
                                    invalidFeedback="Must be three(3) characters."
                                    :value.sync="$v.template_prompt.name.$model"
                                    :isValid="checkIfValid($v.template_prompt, 'name')" />
                            </CCol>
                            <CCol lg="6" md="6" xl="6">
                                <label>Select AI Model for OCR</label>
                                <v-select :options="ai_model_options" :clearable="false"
                                    v-model="selected_ai_model" :label="'name'" :disabled="!edit"
                                    />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol lg="12" md="12" xl="12">
                                <CTextarea class="grp-text-area" :lazy="false" :disabled="!edit" label="Description"
                                    autocomplete="off" v-tocapitalize v-model="template_prompt.description"
                                    :value.sync="$v.template_prompt.description.$model"
                                    :isValid="checkIfValid($v.template_prompt, 'description')" />
                                <br>
                                <CCard>
                                    <CCardHeader @click="tagging_collapse = !tagging_collapse">
                                        <font-awesome-icon icon="tags"/>
                                        Tagging Prompt
                                        <font-awesome-icon 
                                            style="color: #4caf50; cursor: pointer; " 
                                            icon="info-circle" 
                                            size="lg" 
                                            @click.stop="showFieldInstructionModal(3, instruction_page)"
                                            v-c-tooltip="{ content: 'View tagging prompt instructions', placement: 'top' }"
                                        />
                                        <font-awesome-icon :icon="tagging_collapse ? 'angle-down' : 'angle-right'" style="float: right;" />
                                        <CButton color="warning" shape="pill" size="sm"
                                            v-c-tooltip="{ content: 'Not Saved', placement: 'top' }"
                                            v-if="changed_template_fields.includes('tagging_prompt')"
                                            style="cursor: default; margin-right: 5px;" class="float-right"
                                        >
                                            <font-awesome-icon icon="fa-exclamation-triangle" />
                                        </CButton>
                                    </CCardHeader>
                                        <CCollapse :show="tagging_collapse">
                                            <CCardBody>
                                                <CTextarea :lazy="false" :rows="15" placeholder="Content..."
                                                    autocomplete="off" v-tocapitalize v-model="template_prompt.tagging_prompt"
                                                    :disabled="!edit" class="prompt-textarea"
                                                    :isValid="checkIfValidModified($v.template_prompt, 'tagging_prompt')" @change="checkPromptItemChanges"/>
                                            </CCardBody>
                                        </CCollapse>
                                </CCard>
                                <CCard>
                                    <CCardHeader @click="extraction_collapse = !extraction_collapse">
                                        <font-awesome-icon icon="sign-out"/>
                                        Extraction Prompt
                                        <font-awesome-icon 
                                            style="color: #4caf50; cursor: pointer; " 
                                            icon="info-circle" 
                                            size="lg" 
                                            @click.stop="showFieldInstructionModal(2, instruction_page)"
                                            v-c-tooltip="{ content: 'View extraction prompt instructions', placement: 'top' }"
                                        />
                                        <font-awesome-icon :icon="extraction_collapse ? 'angle-down' : 'angle-right'" style="float: right;" />
                                        <CButton color="warning" shape="pill" size="sm"
                                            v-c-tooltip="{ content: 'Not Saved', placement: 'top' }"
                                            v-if="changed_template_fields.includes('extraction_prompt')"
                                            style="cursor: default; margin-right: 5px;" class="float-right"
                                        >
                                            <font-awesome-icon icon="fa-exclamation-triangle" />
                                        </CButton>
                                    </CCardHeader>
                                        <CCollapse :show="extraction_collapse">
                                            <CCardBody>
                                                <CTextarea :lazy="false" :rows="15" placeholder="Content..."
                                                    autocomplete="off" v-tocapitalize v-model="template_prompt.extraction_prompt"
                                                    :disabled="!edit" class="prompt-textarea"
                                                    :isValid="checkIfValidModified($v.template_prompt, 'extraction_prompt')" @change="checkPromptItemChanges"/>
                                            </CCardBody>
                                        </CCollapse>
                                </CCard>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol col="6">
                                <label>Select a prompt to compare within the mainfile</label>
                                <v-select :options="mainfile_comparison_options" :clearable="false"
                                    v-model="selected_mainfile_comparison" :disabled="!edit" />
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol lg="5">
                <CCard>
                    <CCardHeader><font-awesome-icon icon="link" /> Prompt Items
                        <CButton v-if="$store.getters['can']('update-document-template-prompt')" size="sm"
                            :disabled="!isValid" color="primary" class="float-right" v-show="edit"
                            @click="openAddPromptModal()">
                            <font-awesome-icon icon="plus" /> Add Prompt Items
                        </CButton>
                    </CCardHeader>
                    <CCardBody>
                        <CTabs :active-tab="my_tab" @update:activeTab="changeTab">
                            <CTab>
                                <template slot="title">
                                    Active Prompt Items <CBadge color="success">( {{[...new
                                        Set(prompt_item_active.map((item) => item.id))].length}} )</CBadge>
                                </template>
                                <CDataTable :items="prompt_item_active" :fields="prompt_items_fields" table-filter
                                    items-per-page-select :items-per-page="4" hover sorter pagination
                                    style="margin-top: 15px;">
                                    <template #name="{ item }">
                                        <td>{{ item.name }}</td>
                                    </template>
                                    <template #action="{ index, item }">
                                        <td>
                                            <div class="d-flex" style="gap: 0.3rem;" v-if="edit">
                                                 <CButton color="warning" shape="pill" size="sm"
                                                    v-c-tooltip="{ content: 'Not Saved', placement: 'top' }"
                                                    v-if="changed_prompt_item_ids.includes(item.id)"
                                                    style="cursor: default;"
                                                    >
                                                    
                                                    <font-awesome-icon icon="fa-exclamation-triangle" />
                                                </CButton>
                                                <CButton color="primary" shape="pill" size="sm"
                                                    @click="openEditPromptModal(index, item)"
                                                    v-c-tooltip="{ content: 'Edit Prompt', placement: 'top' }">
                                                    <font-awesome-icon icon="pencil" />
                                                </CButton>
                                                <CButton 
                                                    color="info" 
                                                    shape="pill" 
                                                    size="sm"
                                                    v-c-tooltip="{ content: 'Copy Prompt', placement: 'top' }"
                                                    @click="copyPromptItem(index)"
                                                >
                                                        <font-awesome-icon icon="copy"/>
                                                </CButton>
                                                <CButton color="danger" shape="pill" size="sm"
                                                    @click="template_prompt.prompt_items.splice(index, 1)"
                                                    v-if="!item.id"
                                                    v-c-tooltip="{ content: 'Remove Prompt', placement: 'top' }">
                                                    <font-awesome-icon icon="times" />
                                                </CButton>
                                                <CButton color="secondary" shape="pill" size="sm"
                                                    @click="archivePrompt(item, index)" v-else
                                                    v-c-tooltip="{ content: 'Archive Prompt', placement: 'top' }">
                                                    <font-awesome-icon icon="trash" />
                                                </CButton>
                                            </div>
                                            <div v-else>
                                                <CButton color="primary" shape="pill" size="sm"
                                                    @click="openEditPromptModal(index, item)"
                                                    v-c-tooltip="{ content: 'View Prompt', placement: 'top' }">
                                                    <font-awesome-icon icon="eye" />
                                                </CButton>
                                            </div>
                                        </td>
                                    </template>
                                </CDataTable>
                            </CTab>
                            <CTab>
                                <template slot="title">
                                    Inactive Prompt Items <CBadge color="danger">( {{[...new
                                        Set(prompt_item_inactive.map((item) => item.id))].length}} )</CBadge>
                                </template>
                                <CDataTable :items="prompt_item_inactive" :fields="prompt_items_fields" table-filter
                                    items-per-page-select :items-per-page="4" hover sorter pagination
                                    style="margin-top: 15px;">
                                    <template #name="{ item }">
                                        <td>{{ item.name }}</td>
                                    </template>
                                    <template #action="{ index, item }">
                                        <td>
                                            <div class="d-flex" style="gap: 0.3rem;" v-if="edit">
                                                <CButton color="primary" shape="pill" size="sm"
                                                    @click="openEditPromptModal(index, item)"
                                                    v-c-tooltip="{ content: 'View Prompt', placement: 'top' }">
                                                    <font-awesome-icon icon="eye" />
                                                </CButton>
                                                <CButton color="success" shape="pill" size="sm"
                                                    @click="restorePromptItem(index, item)"
                                                    v-c-tooltip="{ content: 'Restore Prompt', placement: 'top' }">
                                                    <font-awesome-icon icon="trash-restore" />
                                                </CButton>
                                            </div>
                                            <div v-else>
                                                <CButton color="primary" shape="pill" size="sm"
                                                    @click="openEditPromptModal(index, item)"
                                                    v-c-tooltip="{ content: 'View Prompt', placement: 'top' }">
                                                    <font-awesome-icon icon="eye" />
                                                </CButton>
                                            </div>
                                        </td>
                                    </template>
                                </CDataTable>
                            </CTab>
                        </CTabs>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>

        <CRow v-show="edit">
            <CCol lg="8">
                <CCard borderColor="danger" v-if="$store.getters['can']('archive-document-template-prompt')">
                    <CCardHeader>
                        <font-awesome-icon icon="exclamation" :style="{ color: 'red' }" />
                        Danger Zone
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol lg="8">
                                <h6>Archive this Document Template Prompt ?</h6>
                            </CCol>
                            <CCol lg="12">
                                <label> Once archived, you cannot use this prompt anymore. Please be certain.</label>
                            </CCol>
                        </CRow>
                        <br>
                        <CRow>
                            <CCol lg="3">
                                <CButton shape="pill" color="warning" @click="archive()">
                                    <font-awesome-icon icon="minus-square" /> Archived
                                </CButton>
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal :show.sync="edit_prompt_modal" color="primary" :closeOnBackdrop="false" size="xl">
            <template #header>
                <h5> <font-awesome-icon icon="sliders-h" /> Edit Prompt </h5>
                <CButton 
                    class="pull-right" 
                    color="light" 
                    shape="pill" 
                    size="sm" 
                    @click="closeEditPromptModal()"
                >
                    <font-awesome-icon icon="times" />
                </CButton>
            </template>
            <template #body-wrapper>
                <CCardBody>

                    <CButton 
                        size="sm" 
                        color="info" 
                        @click="toggleEdit" 
                        v-show="!edit && !isPromptItemArchived"
                        style="margin-bottom: 10px;"
                    >
                        <font-awesome-icon icon="edit"/> Edit
                    </CButton>

                    <CRow>
                        <CCol lg="6" md="6" xl="6">
                            <label>
                                    Document Name 
                                    <font-awesome-icon 
                                        style="color: #4caf50; cursor: pointer; " 
                                        icon='info-circle' 
                                        v-c-tooltip="{ content: 'Always use the complete document name', placement: 'top' }"
                                    />
                            </label>
                            <CInput :lazy="false" type="text" placeholder="(e.g Client Purchase Order)"
                                autocomplete="off" v-tocapitalize v-model="edit_prompt.name"
                                invalidFeedback="Must be three(3) characters." :value.sync="$v.edit_prompt.name.$model"
                                :disabled="!edit || isPromptItemArchived" :isValid="checkIfValid($v.edit_prompt, 'name')" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol>
                            <CCard>
                                <CCardHeader @click="edit_prompt_item_comparison_collapse = !edit_prompt_item_comparison_collapse">
                                    <font-awesome-icon icon="balance-scale"/>
                                    Comparison Prompt
                                    <font-awesome-icon 
                                        style="color: #4caf50; cursor: pointer; " 
                                        icon="info-circle" 
                                        size="lg" 
                                        @click.stop="showFieldInstructionModal(1, instruction_page)"
                                        v-c-tooltip="{ content: 'View comparison prompt instructions', placement: 'top' }"
                                    />
                                    <font-awesome-icon :icon="edit_prompt_item_comparison_collapse ? 'angle-down' : 'angle-right'" style="float: right;" />
                                </CCardHeader>
                                <CCollapse :show="edit_prompt_item_comparison_collapse">
                                    <CCardBody>
                                        <CTextarea :lazy="false" placeholder="Content..." autocomplete="off"
                                            v-tocapitalize v-model="edit_prompt.comparison_prompt" :value.sync="$v.edit_prompt.comparison_prompt.$model"
                                            :disabled="!edit || isPromptItemArchived" :isValid="checkIfValid($v.edit_prompt, 'comparison_prompt')" :rows="20" class="prompt-textarea"/>
                                    </CCardBody>
                                </CCollapse>
                            </CCard>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol>
                            <CCard>
                                <CCardHeader @click="edit_prompt_item_extraction_collapse = !edit_prompt_item_extraction_collapse">
                                    <font-awesome-icon icon="sign-out"/>
                                    Extraction Prompt
                                    <font-awesome-icon 
                                        style="color: #4caf50; cursor: pointer; " 
                                        icon="info-circle" 
                                        size="lg" 
                                        @click.stop="showFieldInstructionModal(2, instruction_page)"
                                        v-c-tooltip="{ content: 'View extraction prompt instructions', placement: 'top' }"
                                    />
                                    <font-awesome-icon :icon="edit_prompt_item_extraction_collapse ? 'angle-down' : 'angle-right'" style="float: right;" />
                                </CCardHeader>
                                <CCollapse :show="edit_prompt_item_extraction_collapse">
                                    <CCardBody>
                                        <CTextarea :lazy="false" placeholder="Content..." autocomplete="off"
                                            v-tocapitalize v-model="edit_prompt.extraction_prompt" :value.sync="$v.edit_prompt.extraction_prompt.$model"
                                            :disabled="!edit || isPromptItemArchived" :isValid="checkIfValid($v.edit_prompt, 'extraction_prompt')" :rows="20" class="prompt-textarea"/>
                                    </CCardBody>
                                </CCollapse>
                            </CCard>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol lg="6" md="6" xl="6">
                            <label>Document Template Category Sets</label>
                            <v-select 
                                label="name"
                                :options="dtcs_lists"
                                v-model="dtcs_id"
                                :disabled="!edit"
                            />
                        </CCol>
                        <CCol lg="6" md="6" xl="6">
                            <label>Attachment Checklist</label>
                            <v-select 
                                label="name"
                                :options="dtcsac_lists"
                                v-model="edit_prompt.dtcsac_id"
                                :disabled="!dtcs_id"
                                :placeholder="!dtcs_id ? 'Select category set first' : ''"
                            />
                        </CCol>
                    </CRow>
                    <br>
                    <CRow>
                        <CCol lg="6" md="6" xl="6">
                            <label>Cross Reference Prompt</label>
                            <v-select 
                                :options="cross_prompt_options" 
                                :clearable="true"
                                v-model="selected_edit_cross_prompt"
                                :disabled="!edit || isPromptItemArchived"
                            />
                        </CCol>
                        <CCol lg="6" md="6" xl="6">
                            <label>Cross Reference Prompt Item</label>
                            <v-select 
                                :options="edit_cross_prompt_item_options" 
                                :clearable="true"
                                v-model="selected_edit_cross_prompt_item"
                                :disabled="!edit || isPromptItemArchived || !selected_edit_cross_prompt || selected_edit_cross_prompt == 'None' || !selected_edit_cross_prompt.value"
                            />
                        </CCol>
                    </CRow>
                    <br>
                    <CRow>
                        <CCol lg="6" md="6" xl="6">
                            <label>Paired Prompt Item</label>
                            <v-select 
                                :options="edit_paired_prompt_item_options" 
                                :clearable="true"
                                v-model="selected_edit_paired_prompt_item"
                                :disabled="!edit || isPromptItemArchived"
                            />
                        </CCol>
                    </CRow>
                    <br>
                    <CRow>
                        <CCol lg="12" md="12" xl="12">
                            <p-check 
                                class="p-icon p-bigger" 
                                color="success" 
                                v-model="is_edit_main_file_checked"
                                @change="onEditMainFileCheckboxChange"
                                :disabled="!edit || isPromptItemArchived"
                            >
                                <font-awesome-icon class="icon" icon="check"/>
                                &nbsp; Set as Internal Attachment Main File
                            </p-check>
                            <br>
                            <small class="text-muted">
                                Only one prompt item can be the main file. Selecting this will unmark any other item currently set.
                            </small>
                        </CCol>
                    </CRow>
                    <br>
                    <CRow>
                        <CCol lg="12">
                            <CButton class="float-right" color="primary" @click="updatePromptItem()" v-show="edit && !isPromptItemArchived">
                                Update
                            </CButton>
                        </CCol>
                    </CRow>
                </CCardBody>
            </template>

            <template #footer>
                <hr hide>
            </template>
        </CModal>
        <CModal :show.sync="add_prompt_items_modal" color="primary" :closeOnBackdrop="false" size="xl">
            <template #header>
                <h5> <font-awesome-icon icon="plus" /> Add Prompt Items</h5>
                <CButton 
                    class="pull-right" 
                    color="light" 
                    shape="pill" 
                    size="sm"
                    @click="closeAddPromptModal()"
                    >
                    <font-awesome-icon icon="times" />
                </CButton>
            </template>
            <template #body-wrapper>
                <CCardBody>
                    <CRow>
                        <CCol lg="6" md="6" xl="6">
                            <label>
                                Document Name 
                                <font-awesome-icon 
                                    style="color: #4caf50; cursor: pointer; " 
                                    icon='info-circle' 
                                    v-c-tooltip="{ content: 'Always use the complete document name', placement: 'top' }"
                                />
                            </label>
                            <CInput :lazy="false" type="text" placeholder="(e.g Client Purchase Order)"
                                autocomplete="off" v-tocapitalize v-model="prompt_items.name"
                                invalidFeedback="Must be three(3) characters." @blur="$v.prompt_items.comparison_prompt.$touch()"
                                :isValid="checkIfValidModified($v.prompt_items, 'name')" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol lg="12" md="12" xl="12">
                            <CCard>
                                <CCardHeader @click="add_prompt_item_comparison_collapse = !add_prompt_item_comparison_collapse">
                                    <font-awesome-icon icon="balance-scale"/>
                                    Comparison Prompt
                                    <font-awesome-icon 
                                        style="color: #4caf50; cursor: pointer; " 
                                        icon="info-circle" 
                                        size="lg" 
                                        @click.stop="showFieldInstructionModal(1, instruction_page)"
                                        v-c-tooltip="{ content: 'View comparison prompt instructions', placement: 'top' }"
                                    />
                                    <font-awesome-icon :icon="add_prompt_item_comparison_collapse ? 'angle-down' : 'angle-right'" style="float: right;" />
                                </CCardHeader>
                                <CCollapse :show="add_prompt_item_comparison_collapse">
                                    <CCardBody>
                                        <CTextarea :lazy="false" :rows="10" placeholder="Content..."
                                            autocomplete="off" v-tocapitalize v-model="prompt_items.comparison_prompt"
                                            @blur="$v.prompt_items.comparison_prompt.$touch()"
                                            :isValid="checkIfValidModified($v.prompt_items, 'prompt')" class="prompt-textarea"/>
                                    </CCardBody>
                                </CCollapse>
                            </CCard>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol lg="12" md="12" xl="12">
                            <CCard>
                                <CCardHeader @click="add_prompt_item_extraction_collapse = !add_prompt_item_extraction_collapse">
                                    <font-awesome-icon icon="sign-out"/>
                                    Extraction Prompt
                                    <font-awesome-icon 
                                        style="color: #4caf50; cursor: pointer; " 
                                        icon="info-circle" 
                                        size="lg" 
                                        @click.stop="showFieldInstructionModal(2, instruction_page)"
                                        v-c-tooltip="{ content: 'View extraction prompt instructions', placement: 'top' }"
                                    />
                                    <font-awesome-icon :icon="add_prompt_item_extraction_collapse ? 'angle-down' : 'angle-right'" style="float: right;" />
                                </CCardHeader>
                                <CCollapse :show="add_prompt_item_extraction_collapse">
                                    <CCardBody>
                                        <CTextarea :lazy="false" :rows="10" placeholder="Content..."
                                            autocomplete="off" v-tocapitalize v-model="prompt_items.extraction_prompt"
                                            @blur="$v.prompt_items.extraction_prompt.$touch()"
                                            :isValid="checkIfValidModified($v.prompt_items, 'prompt')" class="prompt-textarea"/>
                                    </CCardBody>
                                </CCollapse>
                            </CCard>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol lg="6" md="6" xl="6">
                           <label>Document Template Category Sets</label>
                           <v-select 
                               label="name"
                               :options="dtcs_lists"
                               v-model="dtcs_id"
                               :disabled="!edit"
                           />
                       </CCol>
                       <CCol lg="6" md="6" xl="6">
                           <label>Attachment Checklist</label>
                           <v-select 
                               label="name"
                               :options="dtcsac_lists"
                               v-model="dtcsac_id"
                               :disabled="!dtcs_id"
                               :placeholder="!dtcs_id ? 'Select category set first' : ''"
                           />
                       </CCol>
                       <CCol lg="6" md="6" xl="6">
                        <label>
                            Paired Prompt Item
                            <font-awesome-icon 
                                style="color: #4caf50; cursor: pointer;" 
                                icon="info-circle" 
                                v-c-tooltip="{ content: 'This item\'s comparison prompt will automatically run against the paired item\'s attachment.', placement: 'top' }"
                            />
                        </label>
                        <v-select 
                            :options="paired_prompt_item_options" 
                            :clearable="true"
                            v-model="selected_paired_prompt_item"
                        />
                    </CCol>
                    </CRow>
                    <CRow>
                        <CCol lg="6" md="6" xl="6">
                            <label>Cross Reference Prompt</label>
                            <v-select 
                                :options="cross_prompt_options" 
                                :clearable="true"
                                v-model="selected_cross_prompt"
                            />
                        </CCol>
                        <CCol lg="6" md="6" xl="6">
                            <label>Cross Reference Prompt Item</label>
                            <v-select 
                                :options="cross_prompt_item_options" 
                                :clearable="true"
                                v-model="selected_cross_prompt_item"
                                :disabled="!selected_cross_prompt || selected_cross_prompt == 'None' || !selected_cross_prompt.value"
                            />
                        </CCol>
                    </CRow>
                    <br>
                    <CRow>
                        <CCol lg="12" md="12" xl="12">
                            <p-check 
                                class="p-icon p-bigger" 
                                color="success" 
                                v-model="is_main_file_checked"
                                @change="onMainFileCheckboxChange"
                            >
                                <font-awesome-icon class="icon" icon="check"/>
                                &nbsp; Set as Internal Attachment Main File
                            </p-check>
                            <br>
                            <small class="text-muted">
                                Only one prompt item can be the main file. Selecting this will unmark any other item currently set.
                            </small>
                        </CCol>
                    </CRow>
                </CCardBody>
            </template>

            <template #footer>
                <CButton :disabled="!prompt_items.name && !prompt_items.comparison_prompt && !prompt_items.extraction_prompt" shape="pill" color="info"
                    @click="addDynamicPromptItems()">
                    <font-awesome-icon icon="plus" /> Add Prompt Item
                </CButton>
            </template>
        </CModal>
        <CModal :show.sync="instruction_modal" color="success" :closeOnBackdrop="false" size="lg">
            <template #header>
                <h5><font-awesome-icon icon="info-circle" /> {{ instruction_title }}</h5>
                <CButton
                    class="pull-right"
                    color="light"
                    shape="pill"
                    size="sm"
                    @click="instruction_modal = false, instruction_page = 1;"
                >
                    <font-awesome-icon icon="times" />
                </CButton>
            </template>
            <div 
                ref="instructionContent" 
                style="max-height: 500px; overflow-y: auto; padding-right: 8px;"
            >
                <p v-html="formattedInstructions"></p>
            </div>
            <template #footer>
                  <div 
                    style="display: flex; justify-content: space-between; align-items: center; width: 100%;" 
                    v-show="max_instruction_page > 1"
                    >
                      <span>
                        Page {{ instruction_page }} of {{ max_instruction_page }}
                      </span>
                      <CButtonGroup>
                          <CButton 
                              color="info" 
                              :disabled="instruction_page == 1 ? true : false"
                              @click="instruction_page--, showFieldInstructionModal(instruction_prompt_type, instruction_page)">
                              <font-awesome-icon icon="arrow-left" /> 
                              Previous
                          </CButton>
                          <CButton 
                              color="info" 
                              :disabled="instruction_page == max_instruction_page ? true : false" 
                              @click="instruction_page++, showFieldInstructionModal(instruction_prompt_type, instruction_page)">
                              Next 
                              <font-awesome-icon icon="arrow-right"/>
                          </CButton>
                      </CButtonGroup>
                  </div>
            </template>
        </CModal>
    </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators"
export default {
    name: 'DocumentTemplateEdit',
    data() {
        return {
            template_prompt: {
                name: '',
                description: '',
                tagging_prompt: '',
                extraction_prompt:'',
                prompt_items: [],
                mainfile_prompt_item_id: '',
                ai_model_id: null
            },
            update_key: 0,
            template_prompt_backup: {},
            disable: 1,
            edit: false,
            prompt_items_fields: [
                { key: 'name', label: 'Document Name' },
                { key: 'action', _style: 'width:20%', sorter: false }
            ],
            prompt_items: {
                name: null,
                comparison_prompt: null,
                extraction_prompt:null,
                dtcsac_id:null,
                paired_prompt_item_name: null,
                cross_prompt_id: null,        
                cross_prompt_item_id: null,   
                is_internal_attachment_main_file: 0,
            },
            edit_prompt_modal: false,
            edit_prompt_index: null,
            edit_prompt: {
                name: null,
                comparison_prompt: null,
                extraction_prompt:null,
                dtcsac_id:null,
                paired_prompt_item_name: null,
                cross_prompt_id: null,
                cross_prompt_item_id: null,
                is_internal_attachment_main_file: 0,
            },
            prompt_item_count: null,
            my_tab: null,
            add_prompt_items_modal: false,
            selected_mainfile_comparison: '',
            mainfile_comparison_options: [
                { value: null, label: 'None' },
            ],
            ai_model_options: [],
            selected_ai_model: null,
            disableWatcher: true,
            changed_prompt_item_ids: [],
            isPromptItemArchived:false,
            tagging_collapse:false,
            extraction_collapse:false,
            prompt_item_comparison_collapse:false,
            prompt_item_extraction_collapse:false,
            edit_prompt_item_comparison_collapse:false,
            edit_prompt_item_extraction_collapse:false,
            add_prompt_item_comparison_collapse:false,
            add_prompt_item_extraction_collapse:false,
            instruction_modal:false,
            instruction_title:'',
            instructions:'',
            instruction_page:1,
            max_instruction_page:null,
            isExpanded: false,
            changed_template_fields:[],
            dtcs_lists: [],
            dtcs_id:null,
            dtcsac_lists:[],
            dtcsac_id:null,
            paired_prompt_item_options: [
                { value: null, label: 'None' },
            ],
            edit_paired_prompt_item_options: [
                { value: null, label: 'None' },
            ],
            selected_paired_prompt_item: 'None',
            selected_edit_paired_prompt_item: 'None',
            cross_prompt_options: [{ value: null, label: 'None' }],
            cross_prompt_item_options: [{ value: null, label: 'None' }],
            edit_cross_prompt_item_options: [{ value: null, label: 'None' }],
            selected_cross_prompt: 'None',
            selected_cross_prompt_item: 'None',
            selected_edit_cross_prompt: 'None',
            selected_edit_cross_prompt_item: 'None',
            _suppressEditCrossReset: false,
            is_main_file_checked: false,
            is_edit_main_file_checked: false,
        }
    },
    computed: {
        isValid() { return !this.$v.template_prompt.$invalid },
        isDirty() { return this.$v.template_prompt.$anyDirty },
        prompt_item_inactive: function () {
            return this.template_prompt.prompt_items.filter((item) => item.deleted_at != null);
        },

        prompt_item_active: function () {
            return this.template_prompt.prompt_items.filter((item) => item.deleted_at == null);

        },
        formattedInstructions() {
            return this.instructions
                ? this.instructions.replace(/(?:\r\n|\r|\n)/g, '<br>')
                : '';
        },
    },
    created() {
        this.getAIModels();
        this.getPrompt();
        this.getDocumentCategorySet();
        this.getCrossPromptOptions();
    },
    validations: {
        template_prompt: {
            name: { required, minLength: minLength(3) },
            description: { required },
        },
        prompt_items: {
            name: { required, minLength: minLength(3) },
            comparison_prompt: { required },
            extraction_prompt: { required },
        },
        edit_prompt: {
            name: { required, minLength: minLength(3) },
            comparison_prompt: { required },
            extraction_prompt: { required },
        },
    },
    watch: {
        selected_mainfile_comparison(newVal) {
            if (this.disableWatcher) return;
            this.template_prompt.mainfile_prompt_item_id = newVal?.value ?? null;
        },
        selected_ai_model(newVal) {
            if (this.disableWatcher) return;
            this.template_prompt.ai_model_id = newVal.id ?? null;
        },
        dtcs_id(newVal) {
            if (newVal) {
                this.getAttachmentChecklist(newVal)
            }
        },
        dtcsac_id(newVal) {
            if (newVal) {
                this.dtcsac_id = newVal ?? null;     
            }
        },
        selected_paired_prompt_item(newVal) {
            this.prompt_items.paired_prompt_item_name = newVal?.value ?? null;
        },
        selected_edit_paired_prompt_item(newVal) {
            this.edit_prompt.paired_prompt_item_name = newVal?.value ?? null;
        },
        selected_cross_prompt(newVal) {
            this.prompt_items.cross_prompt_id = newVal?.value ?? null;
            this.onAddCrossPromptChange(newVal);
        },
        selected_cross_prompt_item(newVal) {
            this.prompt_items.cross_prompt_item_id = newVal?.value ?? null;
        },
        selected_edit_cross_prompt(newVal) {
            this.onEditCrossPromptChange(newVal);
        },
        selected_edit_cross_prompt_item(newVal) {
            this.edit_prompt.cross_prompt_item_id = newVal?.value ?? null;
        },
    },
    methods: {
        archive: function () {
            this.$swal({
                icon: "warning",
                title: "Are you sure?",
                text: `You are trying to archive the ${this.template_prompt.name}`,
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                preConfirm: () => {
                    this.$Progress.start()
                    return axios.post('drs/document-template-prompt/archive/' + this.$route.params.id, { validateStatus: () => true })
                        .then(response => {
                            if (response.status == 200) {
                                this.update_key++;
                                this.template_prompt_backup.status = 'Archived'
                                this.returnInformation()
                                this.toggleEdit()
                                this.$Progress.finish()
                                this.$swal({
                                    toast: true,
                                    position: 'top-right',
                                    timer: 3000,
                                    icon: 'success',
                                    title: `${this.template_prompt.name} successfully archived.`,
                                    showConfirmButton: false,
                                    timerProgressBar: true,
                                })
                            }
                        })
                }
            }).then((result) => {
                if (!result.value) {
                    this.$swal('Cancelled!', '', 'error');
                }
            })
        },
        restore: function () {
            this.$Progress.start()
            axios.post('drs/document-template-prompt/restore/' + this.$route.params.id, { validateStatus: () => true })
                .then(response => {
                    if (response.status == 200) {
                        this.update_key++;
                        this.template_prompt_backup.status = 'Active'
                        this.returnInformation()
                        // this.toggleEdit()
                        this.$Progress.finish()

                        this.$swal({
                            toast: true,
                            position: 'top-right',
                            timer: 3000,
                            icon: 'success',
                            title: `${this.template_prompt.name} restored successfully.`,
                            showConfirmButton: false,
                            timerProgressBar: true,
                        })
                    }
                })
        },
        getPrompt: function () {
            axios.get('drs/document-template-prompt/' + this.$route.params.id, { validateStatus: () => true })
                .then(response => {
                    if (response.status == 200) {
                        const data = response.data.data;

                        this.template_prompt.name = response.data.data.name
                        this.template_prompt.description = response.data.data.description
                        this.template_prompt.status = response.data.data.deleted_at ? "Archived" : "Active";
                        this.template_prompt.prompt_items = response.data.data.document_template_prompt_items
                        this.template_prompt.tagging_prompt = response.data.data.tagging_prompt
                        this.template_prompt.mainfile_prompt_item_id = response.data.data.mainfile_prompt_item_id;
                        this.template_prompt.extraction_prompt = response.data.data.extraction_prompt
                        this.template_prompt.ai_model_id = response.data.data.ai_model_id

                        this.template_prompt.prompt_items = data.document_template_prompt_items.map(item => ({
                            ...item,
                            dtcsac_id: item.document_template_category_set_attachment_checklist
                                ? {
                                    id: item.document_template_category_set_attachment_checklist.id,
                                    name: item.document_template_category_set_attachment_checklist.name
                                }
                                : null
                        }));

                        this.template_prompt.prompt_items = this.template_prompt.prompt_items.map(item => ({
                            ...item,
                            paired_prompt_item_name: item.paired_template_prompt_id
                                ? (this.template_prompt.prompt_items.find(p => p.id == item.paired_template_prompt_id)?.name || null)
                                : null,
                        }));


                        this.mainfile_comparison_options = [
                            { value: null, label: 'None' }
                        ],

                        this.mainfile_comparison_options.push(
                            ...this.template_prompt.prompt_items.map(item => ({
                                label: item.name,
                                value: item.name,
                            }))
                        );

                        this.paired_prompt_item_options = [{ value: null, label: 'None' }];
                        this.paired_prompt_item_options.push(
                            ...this.template_prompt.prompt_items.map(item => ({
                                label: item.name,
                                value: item.name,
                            }))
                        );

                        this.template_prompt_backup = JSON.parse(JSON.stringify(this.template_prompt))

                        this.selected_ai_model = this.template_prompt.ai_model_id
                            ? this.ai_model_options.find(model => model.id == this.template_prompt.ai_model_id)?.name || 'None'
                            : 'None';

                        this.selected_mainfile_comparison = this.template_prompt.mainfile_prompt_item_id
                            ? this.template_prompt.prompt_items.find(item => item.id == this.template_prompt.mainfile_prompt_item_id)?.name || 'None'
                            : 'None';

                        this.$nextTick(() => {
                            this.disableWatcher = false;
                        });
                    }
                })
        },
        refreshDropdownOptions: function () {
            const mainfileOptions = this.template_prompt.prompt_items.map(item => ({
                label: item.name,
                value: item.name,
            }));

            this.mainfile_comparison_options = [{ label: 'None', value: null }, ...mainfileOptions];

            const alreadyUsed = this.getAlreadyPairedTargetNames();

            const pairedOptions = this.template_prompt.prompt_items
                .filter(item => !alreadyUsed.includes(item.name))
                .map(item => ({
                    label: item.name,
                    value: item.name,
                }));

            this.paired_prompt_item_options = [{ label: 'None', value: null }, ...pairedOptions];
        },
        returnInformation: function () {
            this.template_prompt = JSON.parse(JSON.stringify(this.template_prompt_backup))
            this.changed_prompt_item_ids = [];
        },
        updatePrompt: function () {

            if (JSON.stringify(this.template_prompt) == JSON.stringify(this.template_prompt_backup)) {
                this.$swal({
                    icon: "info",
                    title: "Opps!",
                    text: "No changes has been made.",
                })
                return;
            }
            this.$swal({
                icon: "warning",
                title: "Are you sure?",
                text: `You are trying to update the ${this.template_prompt.name}`,
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                preConfirm: () => {
                    this.$Progress.start()

                    this.template_prompt.prompt_items = this.template_prompt.prompt_items.map(item => ({
                        ...item,
                        dtcsac_id: item.dtcsac_id?.id ?? null,
                    }));


                    return axios.post('drs/document-template-prompt/update/' + this.$route.params.id, this.template_prompt, { validateStatus: () => true })
                        .then(response => {
                            if (response.status == 200) {
                                this.$swal({
                                    toast: true,
                                    position: 'top-right',
                                    timer: 3000,
                                    icon: 'success',
                                    title: `${this.template_prompt.name} successfully updated.`,
                                    showConfirmButton: false,
                                    timerProgressBar: true,
                                })
                                this.update_key++;

                                this.template_prompt.name = response.data.data.name
                                this.template_prompt.status = response.data.data.deleted_at ? "Archived" : "Active";
                                this.template_prompt_backup = JSON.parse(JSON.stringify(this.template_prompt))
                                this.changed_template_fields = [];
                                this.returnInformation()
                                this.toggleEdit()
                                this.getPrompt();
                                this.$Progress.finish()
                            }
                        })
                }
            }).then((result) => {
                if (!result.value) {
                    this.$swal('Cancelled!', '', 'error');
                }
            })
        },
        toggleEdit: function () {
            this.edit = !this.edit
            this.disable = (this.disable + 1) % 2
            if (!this.disable) {
                this.$v.template_prompt.$touch()
                this.$v.$touch()
            }
            else {
                this.$v.template_prompt.$reset()
                this.$v.$reset()

            }
        },
        checkIfValidModified(object, fieldName) {
            const field = object?.[fieldName];
            if (!field || !field.$dirty) return null;
            return !(field.$invalid || field.$model == '');
        },
        addDynamicPromptItems: function () {
            if (this.prompt_items.name && this.prompt_items.comparison_prompt) {

                const isDuplicate = this.template_prompt.prompt_items.some(
                    item => item.name == this.prompt_items.name || item.comparison_prompt == this.prompt_items.comparison_prompt 
                                            || item.extraction_prompt == this.prompt_items.extraction_prompt
                );

                if (isDuplicate) {
                    this.$swal({
                        icon: "warning",
                        title: "Duplicate Entry!",
                        text: "This prompt item already exists.",
                    });
                    return;
                }

                this.template_prompt.prompt_items.push({
                    name: this.prompt_items.name,
                    comparison_prompt: this.prompt_items.comparison_prompt,
                    extraction_prompt: this.prompt_items.extraction_prompt,
                    dtcsac_id: this.dtcsac_id ?? null,
                    paired_prompt_item_name: this.prompt_items.paired_prompt_item_name ?? null,
                    cross_prompt_id: this.prompt_items.cross_prompt_id ?? null,
                    cross_prompt_item_id: this.prompt_items.cross_prompt_item_id ?? null,
                    is_internal_attachment_main_file: this.prompt_items.is_internal_attachment_main_file ?? 0,
                });

                if (this.prompt_items.is_internal_attachment_main_file == 1) {
                    this.template_prompt.prompt_items = this.template_prompt.prompt_items.map((item, idx, arr) => {
                        const isLastPushed = idx === arr.length - 1;
                        return isLastPushed ? item : { ...item, is_internal_attachment_main_file: 0 };
                    });
                }

                this.refreshDropdownOptions();

                this.$v.prompt_items.$reset()
                this.$v.prompt_items.$touch()
                this.resetPromptItems();
                this.add_prompt_items_modal = false;
            } else {
                this.$swal({
                    icon: "error",
                    title: "Error!",
                    text: "Please fill up all fields.",
                })
            }
        },
        resetPromptItems: function () {
            this.prompt_items = {
                name: null,
                comparison_prompt: null,
                extraction_prompt: null,
                dtcsac_id:null,
                cross_prompt_id: null,
                cross_prompt_item_id: null,
                is_internal_attachment_main_file: 0,
            }
            this.dtcs_id = null;
            this.dtcsac_id = null;
            this.selected_paired_prompt_item = 'None';
            this.selected_cross_prompt = 'None';
            this.selected_cross_prompt_item = 'None';
            this.cross_prompt_item_options = [{ label: 'None', value: null }];
            this.is_main_file_checked = false;
        },
        resetPrompt: function () {
            this.template_prompt = {
                name: '',
                description: '',
                prompt_items: [],
            }
        },
        openEditPromptModal(index, item) {
            const fullIndex = this.template_prompt.prompt_items.findIndex(
                prompt => prompt.name == item.name && prompt.comparison_prompt == item.comparison_prompt && prompt.extraction_prompt == item.extraction_prompt
            );

            if (fullIndex == -1) return;

            const isActive = item.deleted_at == null;
            let selectedItem;

            if (isActive) {
                selectedItem = this.prompt_item_active[index];
                this.isPromptItemArchived = false;
            } else {
                selectedItem = this.prompt_item_inactive[index];
                this.isPromptItemArchived = true;
            }
            this.edit_prompt = { ...selectedItem };
            this.edit_prompt_index = fullIndex;

            this.is_edit_main_file_checked = selectedItem.is_internal_attachment_main_file == 1;

            const currentPairedName = this.edit_prompt.paired_prompt_item_name;
            const alreadyUsed = this.getAlreadyPairedTargetNames(this.edit_prompt.name)
                .filter(name => name !== currentPairedName);

            this.edit_paired_prompt_item_options = [
                { label: 'None', value: null },
                ...this.template_prompt.prompt_items
                    .filter((_, idx) => idx !== fullIndex) 
                    .filter(promptItem => !alreadyUsed.includes(promptItem.name)) 
                    .map(promptItem => ({
                        label: promptItem.name,
                        value: promptItem.name,
                    }))
            ];

            this.selected_edit_paired_prompt_item = this.edit_prompt.paired_prompt_item_name
                ? { label: this.edit_prompt.paired_prompt_item_name, value: this.edit_prompt.paired_prompt_item_name }
                : 'None';

            if (this.edit_prompt.cross_prompt_item_id && this.edit_prompt.cross_prompt_item) {
                const owningPromptId = this.edit_prompt.cross_prompt_item.document_template_prompt_id;

                this._suppressEditCrossReset = true;

                const match = this.cross_prompt_options.find(o => o.value == owningPromptId);
                this.selected_edit_cross_prompt = match || 'None';
                this.edit_prompt.cross_prompt_id = owningPromptId;

                this.$nextTick(() => {
                    this._suppressEditCrossReset = false;
                });

                this.getCrossPromptItems(owningPromptId, 'edit', this.edit_prompt.cross_prompt_item_id);
            } else {
                this.selected_edit_cross_prompt = 'None';
                this.edit_cross_prompt_item_options = [{ label: 'None', value: null }];
                this.selected_edit_cross_prompt_item = 'None';
            }

            this.edit_prompt_modal = true;
        },
        updatePromptItem() {
            if (!this.edit_prompt.name || !this.edit_prompt.comparison_prompt || !this.edit_prompt.extraction_prompt) {
                this.$swal({
                    icon: 'error',
                    title: 'Error!',
                    text: 'Please fill up all fields.',
                });
                return;
            }

            const isDuplicate = this.template_prompt.prompt_items.some((item, idx) => {
                return (
                    idx !== this.edit_prompt_index &&
                    item.name == this.edit_prompt.name &&
                    item.comparison_prompt == this.edit_prompt.comparison_prompt &&
                    item.extraction_prompt == this.edit_prompt.extraction_prompt
                );
            });

            if (isDuplicate) {
                this.$swal({
                    icon: 'warning',
                    title: 'Duplicate Entry!',
                    text: 'This prompt item already exists.',
                });
                return;
            }
            
            this.$set(this.template_prompt.prompt_items, this.edit_prompt_index, { ...this.edit_prompt });
            this.refreshDropdownOptions();

            if (this.edit_prompt.is_internal_attachment_main_file === 1) {
                this.template_prompt.prompt_items = this.template_prompt.prompt_items.map((item, idx) => {
                    return idx === this.edit_prompt_index ? item : { ...item, is_internal_attachment_main_file: 0 };
                });
            }
            
            this.edit_prompt_modal = false;
            this.edit_prompt = { name: null, comparison_prompt: null, extraction_prompt: null, dtcsac_id: null };
            this.edit_prompt_index = null;
            this.dtcs_id = null;
            this.dtcsac_id = null;
            this.selected_edit_paired_prompt_item = 'None'; 
            this.selected_edit_cross_prompt = 'None';
            this.selected_edit_cross_prompt_item = 'None';
            this.is_edit_main_file_checked = false;
            this.checkPromptItemChanges();
        },
        archivePrompt: function (item, index) {
            let promptName = item.name;

            this.prompt_item_count = this.template_prompt.prompt_items.filter(item => {
                return item.deleted_at == null;
            }).length;

            if (this.prompt_item_count == 1) {
                this.$swal('Action denied', 'At least one API parameter is required.', 'warning');
                return;
            }
            // if (this.reference_param_id == item.id) { // default prompt
            //     this.$swal('Action denied', `This parameter is a reference number and can't be archived.`, 'warning');
            //     return;
            // }

            this.$swal({
                icon: "warning",
                title: "Are you sure?",
                html: `You are trying to Archive the <b>${promptName}</b> Prompt Item.`,
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                preConfirm: () => {
                    this.$Progress.start()
                    return axios.post('drs/document-template-prompt/archive-prompt-item/' + item.id,
                        { validateStatus: () => true })
                        .then(response => {
                            if (response.status == 200) {
                                this.$swal({
                                    icon: "success",
                                    title: "Success!",
                                    html: `<b>${promptName}</b> Successfully archived.`,
                                })
                                this.template_prompt.prompt_items.splice(index, 1)
                                this.$Progress.finish()
                                this.getPrompt();

                            }
                        })
                }
            }).then((result) => {
                if (!result.value) {
                    this.$swal('Cancelled!', '', 'error');
                }
            })
            return;
        },
        changeTab: function (item) {
            this.my_tab = item
        },
        restorePromptItem(index, item) {
            let promptName = item.name;

            this.$swal({
                icon: "warning",
                title: "Are you sure?",
                html: `You are trying to restore the <b>${promptName}</b> Prompt Item.`,
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                preConfirm: () => {
                    this.$Progress.start()
                    return axios.post('drs/document-template-prompt/restore-prompt-item/' + item.id,
                        { validateStatus: () => true })
                        .then(response => {
                            if (response.status == 200) {
                                this.$swal({
                                    icon: "success",
                                    title: "Success!",
                                    html: `<b>${promptName}</b> Successfully restored.`,
                                })
                                // this.template_prompt.prompt_items.splice(index, 1)
                                this.$Progress.finish()
                                this.getPrompt();

                            }
                        })
                }
            }).then((result) => {
                if (!result.value) {
                    this.$swal('Cancelled!', '', 'error');
                }
            })
            return;
        },
        checkPromptItemChanges(){
            this.changed_prompt_item_ids = [];
            this.changed_template_fields = [];

            this.template_prompt.prompt_items.forEach((item, index) => {
                const backupItem = this.template_prompt_backup.prompt_items[index];

                if (!backupItem || 
                    item.id !== backupItem.id || 
                    item.name !== backupItem.name || 
                    item.comparison_prompt != backupItem.comparison_prompt || 
                    item.extraction_prompt != backupItem.extraction_prompt ||
                    item.dtcsac_id?.id !== backupItem.dtcsac_id?.id ||
                    item.paired_prompt_item_name !== backupItem.paired_prompt_item_name ||
                    item.cross_prompt_item_id !== backupItem.cross_prompt_item_id ||
                    item.is_internal_attachment_main_file != backupItem.is_internal_attachment_main_file
                ) {
                    if (item.id != null) {
                        this.changed_prompt_item_ids.push(item.id);
                    }
                }
            });

            if (this.template_prompt.tagging_prompt !== this.template_prompt_backup.tagging_prompt) {
                this.changed_template_fields.push('tagging_prompt');
            }

            if (this.template_prompt.extraction_prompt !== this.template_prompt_backup.extraction_prompt) {
                this.changed_template_fields.push('extraction_prompt');
            }
        },
        copyPromptItem: function (index) {
            this.$swal({
                icon: "warning",
                title: "Are you sure?",
                text: `You are trying to copy the prompt item selected. Please note that this action will create a new form that is identical to the selected form.`,
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                preConfirm: () => { 
                    const itemToCopy = this.template_prompt.prompt_items[index];

                    if (itemToCopy) {
                        const randomId = Math.random().toString(36).substring(2, 8);

                        const copiedItem = {
                            name: `${randomId}`,
                            comparison_prompt: itemToCopy.comparison_prompt,
                            extraction_prompt: itemToCopy.extraction_prompt,
                            dtcsac_id: itemToCopy.dtcsac_id ?? null,
                            paired_prompt_item_name: null,
                            is_internal_attachment_main_file: 0,
                        };

                        const isDuplicate = this.template_prompt.prompt_items.some(
                            item => item.name == copiedItem.name && item.comparison_prompt == copiedItem.comparison_prompt
                                    && item.extraction_prompt == copiedItem.extraction_prompt
                        );

                        if (isDuplicate) {
                            this.$swal({
                                icon: "warning",
                                title: "Duplicate Entry!",
                                text: "This copied prompt item already exists.",
                            });
                            return;
                        }

                        this.template_prompt.prompt_items.push(copiedItem);

                        this.mainfile_comparison_options = [{ label: 'None', value: null }];
                        this.mainfile_comparison_options.push(
                            ...this.template_prompt.prompt_items.map(item => ({
                                label: item.name,
                                value: item.name,
                            }))
                        );
                    }
                    }
            })
        },
        showFieldInstructionModal(prompt_type, page) {
            //prompt_type 1 = comparison prompt
            //prompt_type 2 = extraction prompt
            //prompt_type 2 = tagging prompt

            this.instruction_prompt_type = null;
            this.max_instruction_page = null;

            if(prompt_type == 1) {
                this.instruction_title = "Comparison Prompt Instructions";
                this.instruction_prompt_type = 1;
                this.max_instruction_page = 4;
                if (page == 1) {
                    this.instructions = `  <div><h4>AI Response Output Instructions</h4><i>The following section defines the expected output format returned by the AI. It explains the required fields, their purpose, and how they are divided between backend processing and frontend display.</i>
    
                                            <b>Backend / Required Fields: </b>
                                            &nbsp;<i>These fields are essential for backend processing and control how the data is grouped, scored, and interpreted:</i>
                                            <b>• field_count </b>
                                            &nbsp;&nbsp;Indicates whether all fields are part of a multi-item set.
                                            &nbsp;&nbsp;&nbsp;All fields are multi-item: set field_count to the number of items (e.g., 8).
                                            &nbsp;&nbsp;&nbsp;Set <b>false</b> if not all fields are multi-item.
                                            <b>• field_group_size. </b>
                                            &nbsp;&nbsp;Used only when is_multi_item is true.
                                            &nbsp;&nbsp;&nbsp;• Specifies how many fields are grouped together as one item.
                                            &nbsp;&nbsp;&nbsp;• For <b>UI purposes only</b>.
                                            &nbsp;&nbsp;&nbsp;• Set to the <b>total number of fields in the group</b> (e.g., 4 if Quantity, Description, Unit Price, and Total Amount are grouped).
                                            <b>• is_multi_item </b>
                                            &nbsp;&nbsp;Indicates whether the document contains <b>multiple items</b>, but not necessarily that all fields are multi-item.
                                            &nbsp;&nbsp;&nbsp;• <b> true </b> → multiple items exist.
                                            &nbsp;&nbsp;&nbsp;• <b> false </b> → only single item or standalone fields.
                                            <b>• weight </b>
                                            &nbsp;&nbsp;Indicates the importance of the field:
                                            &nbsp;&nbsp;&nbsp;• <b> primary </b> → main field for scoring/comparison.
                                            &nbsp;&nbsp;&nbsp;• <b> secondary </b>→ supporting field for scoring/comparison.
                                            &nbsp;&nbsp;&nbsp;• <b> none and item_bundle </b>→ display-only field (not scored).
                                            <b>• based_gp </b>
                                            &nbsp;&nbsp;• based_gp is used to check whether the GP percent falls below the defined base GP (e.g., 9). This is for UI purposes only, to display a warning label when the GP percent is lower than based_gp.
                                            </div>
                                            <b>Frontend / Table Display Fields: </b>
                                            &nbsp;&nbsp;<i>These fields are used to populate the HTML table in the UI:</i>
                                            &nbsp;&nbsp;&nbsp;• attachment_header
                                            &nbsp;&nbsp;&nbsp;• mainfile_label
                                            &nbsp;&nbsp;&nbsp;• mainfile_value
                                            &nbsp;&nbsp;&nbsp;• attachment_label
                                            &nbsp;&nbsp;&nbsp;• attachment_value
                                            &nbsp;&nbsp;&nbsp;• reason
                                            &nbsp;&nbsp;&nbsp;• result
                                            <br>
                                            <b>AI Response Output Format:</b>
                                            <div style="border: 1px solid #ccc; padding: 12px; border-radius:5px; background-color:#D8DBE0; font-family: monospace;">{
                                                &nbsp;&nbsp;"json_data": [
                                                &nbsp;&nbsp;&nbsp;&nbsp;{
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"attachment_header": "Attachment File Title",
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"mainfile_label": "Field name from main file",
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"mainfile_value": "Value from main file",
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"attachment_label": "Field name from attachment file",
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"attachment_value": "Value from attachment file",
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"reason": "The descriptions match closely with slight variation.",
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"weight": "primary",
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"result": 9,
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"field_count": false,
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"field_group_size": 4,
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"is_multi_item": true
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"based_gp": 9
                                                &nbsp;&nbsp;&nbsp;&nbsp;},
                                                &nbsp;&nbsp;&nbsp;&nbsp;...
                                                &nbsp;&nbsp;]
                                                }
                                            </div>`;
                } else if(page == 2){
                    this.instructions = `  <div><h4>Instructions for Defining Fields to Compare</h4><i>When specifying fields, always follow this format to ensure consistency in the AI’s response:</i>
    
                                            <b>Field Name & Weight </b>
                                            &nbsp;&nbsp;• Write the field name clearly.
                                            &nbsp;&nbsp;• Specify its weight (primary, secondary, item_bundle or none).
                                            &nbsp;&nbsp;• If the weight is none or item_bundle, the field is display-only and will not be scored..
                                            <b>JSON Key </b>
                                            &nbsp;&nbsp;• Provide the exact JSON key that will represent this field in the AI output.
                                            <b>Scoring Guide (if applicable)</b>
                                            &nbsp;&nbsp;• In certain cases, a field may require special evaluation criteria (e.g., abbreviations, numeric formatting, or recognized name variations). When applicable, a scoring guide must be provided to explicitly define these rules.
                                            &nbsp;&nbsp;• If weight is none or item_bundle, skip the scoring guide.
                                            <b>Blank Handling</b>
                                            &nbsp;&nbsp;• If the weight is none or item_bundle, the AI must leave attachment_value and reason blank in the response.
                                            </div>
                            
                                            <b>Example Format:</b>
                                            <div style="border: 1px solid #ccc; padding: 12px; border-radius:5px; background-color:#D8DBE0; font-family: monospace;">1. Client Name (weight: primary)  
                                            &nbsp;&nbsp;- JSON key is "client_name"  
                                            &nbsp;&nbsp;Client Name Scoring Guide:  
                                            &nbsp;&nbsp;- Focus on the company's identity, not exact words.
    
                                            2. Client PO Number (weight: primary)  
                                            &nbsp;&nbsp;- JSON key is "client_po_number"
    
                                            3. Credit Terms (weight: none)  
                                            &nbsp;&nbsp;- JSON key is "credit_terms"  
                                            &nbsp;&nbsp;- Show only the main file label and value; keep attachment value and reason blank
                                            </div>`;
                }
                else if(page == 3){
                    this.instructions = `  <div><h4>Handling Multi-Item Fields</h4><i>Multi-item fields require special handling in order to ensure consistency and accuracy in the AI's output. There are two distinct scenarios:</i>
                                            
                                            <h5>Case 1: Mixed Schema (Not All Fields Are Multi-Item)</h5><b>Define the Required Fields per Item</b>
                                            <i>List all the required fields for each item. For example:</i>
                                            <div style="border: 1px solid #ccc; padding: 12px; border-radius:5px; background-color:#D8DBE0; font-family: monospace;">**Each item must always output exactly 4 fields, no more and no less:**
                                            &nbsp;&nbsp;1.Quantity
                                            &nbsp;&nbsp;2.Item Description
                                            &nbsp;&nbsp;3.Unit Price
                                            &nbsp;&nbsp;4.Total Amount
                                            </div>
                                            <i>Next, define clear guidelines on how the output should be structured. For example:</i>
                                            <div style="border: 1px solid #ccc; padding: 12px; border-radius:5px; background-color:#D8DBE0; font-family: monospace;">**For every item in the array, repeat all 4 fields without skipping any.**
                                            The total number of fields = number of items x 4. Example:
                                            If there are 3 items -> 12 fields must be present.
                                            If there are 4 items -> 16 fields must be present.
                                            **Fields must always follow the same sequence:**
                                            &nbsp;&nbsp;1.Quantity
                                            &nbsp;&nbsp;2.Item Description
                                            &nbsp;&nbsp;3.Unit Price
                                            &nbsp;&nbsp;4.Total Amount
                                            </div>
    
                                            <h5>Case 2: Fully Multi-Item Schema (All Fields Are Multi-Item)</h5><i>When every field belongs to a repeating group per item:</i>
                                            <i>List all the required fields for each item. For example:</i>
                                            <div style="border: 1px solid #ccc; padding: 12px; border-radius:5px; background-color:#D8DBE0; font-family: monospace;">**Each item must always output exactly 4 fields, no more and no less:**
                                            &nbsp;&nbsp;(Item [n]) Factor Rate
                                            &nbsp;&nbsp;(Item [n]) Forex (Foreign Exchange / Currency Conversion)
                                            &nbsp;&nbsp;(Item [n]) Quantity
                                            &nbsp;&nbsp;(Item [n]) Item Description
                                            &nbsp;&nbsp;(Item [n]) (Item [n]) Unit Cost
                                            &nbsp;&nbsp;(Item [n]) (Item [n]) Total Cost
                                            &nbsp;&nbsp;(Item [n]) Availability based on supplier quotation (OS/OB)
                                            </div>
                                            <i>Next, define clear guidelines on how the output should be structured. For example:</i>
                                            <div style="border: 1px solid #ccc; padding: 12px; border-radius:5px; background-color:#D8DBE0; font-family: monospace;">- Replace [n] with the item number (e.g., Item 1, Item 2, etc.).
                                            For example:                                        
                                            If there are 3 items -> 12 fields must be present.
                                            If there are 4 items -> 16 fields must be present.
                                            **Fields must always follow the same sequence:**
                                            &nbsp;&nbsp;- (Item 1) Factor Rate
                                            &nbsp;&nbsp;- (Item 1) Forex
                                            &nbsp;&nbsp;- (Item 2) Factor Rate
                                            &nbsp;&nbsp;- (Item 2) Forex
                                            &nbsp;&nbsp; ...and so on.
                                            - For example If there are three products, your output must contain exactly 21 fields:(7 fields x 3 products). 
                                            - 7 fields for Item 1 (all prefixed with "Item 1")
                                            - 7 fields for Item 2 (all prefixed with "Item 2")
                                            - 7 fields for Item 3 (all prefixed with "Item 3")
                                            </div>
                                            </div>`;
                }
                else if(page == 4){
                    this.instructions = `  <div><h4>Full Sample of a Comparison Prompt</h4><b><i>The following rules apply to the sample prompt provided above:</i></b>
                                            &nbsp;&nbsp;• All fields are multi-item.
                                            &nbsp;&nbsp;• field_count is 7, meaning the 7 fields are grouped together.
                                            &nbsp;&nbsp;• Among these 7 fields, each has an assigned weight, and 3 fields are display-only.
    
                                            <div style="border: 1px solid #ccc; padding: 12px; border-radius:5px; background-color:#D8DBE0; font-family: monospace;">You are a document comparison specialist.
    
                                                Objective:
                                                - Compare pages from the Main File (Job Order) Page against the Purchase Requisition Slip Page only. Do not compare pages within the same document. The Main File (Job Order) is the standard reference (baseline), while the Purchase Requisition Slip Page is compared against it.
    
                                                Strict Rules:
                                                - Do not use values from Main File (Job Order) for Purchase Requisition Slip.
    
                                                - Ensure strict data origin consistency: values from each file must remain within their respective fields.
    
                                                - If a field is missing or empty, assign a score of 0 in the result.
    
                                                - Format the output as JSON only, without escape characters, backslashes, or code blocks.
    
                                                - Long content exceeding ~30 characters should be truncated with "..." and represented with a tooltip or popover (you can use summarization).
    
                                                Output Format:
                                                {
                                                &nbsp;&nbsp;"json_data": [
                                                &nbsp;&nbsp;&nbsp;&nbsp;{
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"attachment_header": "Attachment File Title",
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"mainfile_label": "Field name from main file",
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"mainfile_value": "Value from main file",
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"attachment_label": "Field name from attachment file",
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"attachment_value": "Value from attachment file",
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"reason": "The descriptions match closely with slight variation.",
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"weight": "primary, secondary, or none",
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"result": 0-10,
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"field_count": 7,
                                                &nbsp;&nbsp;&nbsp;&nbsp;},
                                                &nbsp;&nbsp;&nbsp;&nbsp;...
                                                &nbsp;&nbsp;]
                                                }
    
                                                Fields to Compare (10 Total):
                                                Important: Each field must be evaluated based on its own specific rules. Do not apply rules from one field to another; If the field weight is 'none', leave it blank in the attachment.
    
                                                    1. Factor Rate (weight: primary)
    
                                                    - JSON key is  “factor_rate”
    
                                                2. Forex (Foreign Exchange / Currency Conversion) (weight: primary)
    
                                                    - JSON key is  “forex”
    
                                                3. Quantity (weight: primary)
    
                                                    - JSON key is  “quantity”
    
                                                4. item_description (weight: primary)
    
                                                    - JSON key is  “item_description”
    
                                                    - Match based on meaning, not formatting
    
                                                5. Contact Number (weight: none)
                                                - JSON key is  “contact_number”
                                                - Show only the main file label and value; keep attachment value and reason blank
    
                                                6. Unit Cost (weight: primary)
    
                                                - JSON key is  “unit_cost”
    
                                                7. Total Cost (weight: primary)
    
                                                - JSON key is  “total_cost”
    
                                                8. Availability Based on Supplier Quotation (On Stock/Order Basis) (weight: primary)
                                                - JSON key is  “availability_based_on_supplier_quotation”
    
                                                9. GP Percent  (weight: none)
                                                - JSON key is  “gp”
                                                - Show only the main file label and value; keep attachment value and reason blank
    
                                                10. Incidental Cost  (weight: none)
                                                - JSON key is  “incidental_cost”
                                                - Show only the main file label and value; keep attachment value and reason blank
    
                                                Fields Instruction:
                                                - For each product in the request for quotation, include exactly 7 fields for comparison in the JSON output.
                                                - These 7 fields must be:
                                                &nbsp;&nbsp;1. (Item [n]) Factor Rate
                                                &nbsp;&nbsp;2. (Item [n]) Forex (Foreign Exchange / Currency Conversion)
                                                &nbsp;&nbsp;3. (Item [n]) Quantity
                                                &nbsp;&nbsp;4. (Item [n]) Item Description
                                                &nbsp;&nbsp;5. (Item [n]) (Item [n]) Unit Cost
                                                &nbsp;&nbsp;6. (Item [n]) (Item [n]) Total Cost
                                                &nbsp;&nbsp;7. (Item [n]) Availability based on supplier quotation (OS/OB)
                                                - Replace [n] with the item number (e.g., Item 1, Item 2, etc.).
                                                For example:
                                                &nbsp;&nbsp;- (Item 1) Factor Rate
                                                &nbsp;&nbsp;- (Item 1) Forex
                                                &nbsp;&nbsp;- (Item 2) Factor Rate
                                                &nbsp;&nbsp;- (Item 2) Forex
                                                &nbsp;&nbsp; ...and so on.
                                                ...and so on.
                                                - For example If there are three products, your output must contain exactly 21 fields:(7 fields x 3 products). 
                                                - 7 fields for Item 1 (all prefixed with “Item 1”)
                                                - 7 fields for Item 2 (all prefixed with “Item 2”)
                                                - 7 fields for Item 3 (all prefixed with “Item 3”)
                                                - Special Rule on Weight = “none”
                                                - If an item's weight is labeled as “none”, then do not generate the 7 repetitive comparison fields for that item.
                                                - Instead, display that field only once under Item 1 (not repeated for the other items).
                                                - Do not add or omit any fields. Ensure each product has a complete set of the eight required fields.
                                            </div>
                                            </div>`;
                }
            } else if(prompt_type == 2){
                this.instruction_title = "Extraction Prompt Instructions";
                this.instruction_prompt_type = 2;
                this.max_instruction_page = 2;
                if(page == 1){
                    this.instructions = `  <div><h4>Prompt Creation Rules (for JSON Output)</h4><i>The following section defines the expected output format returned by the AI and outlines the required fields to be extracted.</i>
                                            
                                            &nbsp;&nbsp;• Always specify the output format.
                                            &nbsp;&nbsp;• Add sample values for each field (e.g., "client_name": "ABC Corporation").
                                            &nbsp;&nbsp;• <b>Add fallback rules - </b> If a field might be missing, specify what to use instead. 
                                            &nbsp;&nbsp;&nbsp;Example: 
                                            &nbsp;&nbsp;&nbsp;&nbsp;• “If Billing Address is missing, use Delivery Address.”
                                            &nbsp;&nbsp;&nbsp;&nbsp;• “If there is no Factor rate in PRS page the value is 1.0”
                                            &nbsp;&nbsp;• Use snake_case or camelCase and never mix them.
                                            &nbsp;&nbsp;• Specify that each item must always have the same set of fields.
                                            &nbsp;&nbsp;• Specify when values must be numeric, text, or a fixed choice. Example: “Entity must be either A or B only.”

                                            <b>Example Format:</b>
                                            <div style="border: 1px solid #ccc; padding: 12px; border-radius:5px; background-color:#D8DBE0; font-family: monospace;">{
                                                &nbsp;&nbsp;"json_data": {  
                                                &nbsp;&nbsp;&nbsp;&nbsp;"client_name": "Labelled 'Client's Name' (e.g: ABC Corporation)",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;"client_po_number": "Labelled 'Client's P.O. No.' (e.g: PO-2025-001)",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;"billing_address": "Labelled 'Billing Address' (e.g: 123 Main St, Cityville); If there is no Billing Address, use the Delivery Address instead",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;"delivery_address": "Labelled 'Delivery Address' (e.g: 456 Delivery Rd, Cityville); If there is no Delivery Address, use the 'Billing Address instead",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;"entity": "Should be 'Accent Micro Technologies, Inc.' or 'AMTI Enterprise'",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;"items": [  
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{  
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"quantity": "Labelled 'Trans QTY' (e.g: 5)",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"item_description": "Labelled 'Description' (include all items)",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"unit_price": "Labelled 'Unit Price' (e.g: 18000)",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"total_amount": "Labelled 'Total Amount' (e.g: 165000)"  
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}  
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;....  
                                                &nbsp;&nbsp;&nbsp;&nbsp;],  
                                                &nbsp;&nbsp;&nbsp;&nbsp;"warranty_description": "(e.g: 1-year manufacturer warranty)",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;"currency": "Currency used in the Client Purchase Order (e.g: PHP)"  
                                                &nbsp;&nbsp;}  
                                                }  
                                            </div>`;
                } else if(page == 2){
                    this.instructions = `  <div><h4>Full Sample of a Extraction Prompt</h4>
                                            <div style="border: 1px solid #ccc; padding: 12px; border-radius:5px; background-color:#D8DBE0; font-family: monospace;">- You are an information extraction assistant.
                                                - Your task is to read the provided document and extract the required fields exactly into the given JSON format.

                                                Instructions:
                                                1. Output only valid JSON — no extra text, no explanations.
                                                2. Use the following schema for your output. Keep labels and formatting exactly as shown, replacing the (e.g: ...) parts with the actual extracted values.
                                                3. If a value is not found, use null instead of leaving it empty.
                                                4. Preserve the exact formatting of values from the document (including capitalization, punctuation, units, currency symbols, and percentages).
                                                5. Do not invent or assume any values not found in the document.
                                                6. Return values exactly as they appear, even if they differ from the examples.
                                                7. You must return exactly 14 fields.
                                                8. Format the output as JSON only, without escape characters, backslashes, or code blocks.

                                                {
                                                &nbsp;&nbsp;"json_data": {  
                                                &nbsp;&nbsp;&nbsp;&nbsp;"client_name": "Labelled 'Client's Name' (e.g: ABC Corporation)",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;"client_po_number": "Labelled 'Client's P.O. No.' (e.g: PO-2025-001)",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;"billing_address": "Labelled 'Billing Address' (e.g: 123 Main St, Cityville); If there is no Billing Address, use the Delivery Address instead",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;"delivery_address": "Labelled 'Delivery Address' (e.g: 456 Delivery Rd, Cityville); If there is no Delivery Address, use the 'Billing Address instead",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;"entity": "Should be 'Accent Micro Technologies, Inc.' or 'AMTI Enterprise'",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;"items": [  
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{  
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"quantity": "Labelled 'Trans QTY' (e.g: 5)",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"item_description": "Labelled 'Description' (include all items)",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"unit_price": "Labelled 'Unit Price' (e.g: 18000)",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"total_amount": "Labelled 'Total Amount' (e.g: 165000)"  
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;}  
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;....  
                                                &nbsp;&nbsp;&nbsp;&nbsp;],  
                                                &nbsp;&nbsp;&nbsp;&nbsp;"warranty_description": "(e.g: 1-year manufacturer warranty)",  
                                                &nbsp;&nbsp;&nbsp;&nbsp;"currency": "Currency used in the Client Purchase Order (e.g: PHP)"  
                                                &nbsp;&nbsp;}  
                                                }  `;
                }
            } else if(prompt_type == 3){
                this.instruction_title = "Tagging Prompt Instructions";
                this.instruction_prompt_type = 3;
                this.max_instruction_page = 1;

                this.instructions = `  <div><h4>Prompt Creation Rules (for Document Tagging)</h4><i>The following section provides detailed guidelines for creating document tagging prompts,outlining the rules for identifying document types.</i>
                                            
                                            &nbsp;&nbsp;• Clearly label the document type (e.g., Client Purchase Order (CPO), Purchase Requisition Slip (PRS)).
                                            &nbsp;&nbsp;• Make sure the document type label are same with the store on the prompt items
                                            &nbsp;&nbsp;• Specify keywords or phrases that appear in the title or heading.
                                            &nbsp;&nbsp;• Mention unique identifiers (e.g., PO Number, PR Number).
                                            &nbsp;&nbsp;• Include common fields that can help confirm the document type.
                                            &nbsp;&nbsp;• Provide a bullet list of fields typically found in the document. Example: Vendor / Supplier Name, Client Name, PO Date.
                                            &nbsp;&nbsp;• Include Table Details (if applicable). Define the column headers that usually appear in tabular data. Example: Item Description, Quantity, Unit Price, Total Amount.

                                            <b>Example Format:</b>
                                            <div style="border: 1px solid #ccc; padding: 12px; border-radius:5px; background-color:#D8DBE0; font-family: monospace;">Client Purchase Order (CPO)
                                            CPO Identification Criteria:
                                            1. Title or heading includes 'Client Purchase Order', 'Purchase Order', or 'PO'
                                            2. A clear 'PO Number' (often starts with PO- or contains keywords like 'PO No.')
                                            3. Fields such as:
                                            - Vendor / Supplier Name
                                            -  Client Name or Bill To / Ship To
                                            -  PO Date
                                            4. table listing:
                                            -  Item / Product Description
                                            -  Quantity
                                            -  Unit Price
                                            -  Total Amount
                                            -  Terms / Delivery Date / Payment Instructions (optional but common)

                                Purchase Requisition Slip (PRS)
                                            PRS Identification Criteria:
                                            1. Title or heading includes 'PURCHASE REQUISITION SLIP'
                                            2. A unique 'Number' or 'PR Number'
                                            3. Fields such as:
                                            -  Operating Unit
                                            -  JO Number
                                            -  Date
                                            -  Client's Name
                                            -  Division/BU
                                            4. A table listing:
                                            -  Item Code
                                            -  Description
                                            -  Supplier Name
                                            -  Quantity (Qty)
                                            -  Unit Price
                                            -  Total Amount 
                                            </div>`;

            }

            this.instruction_modal = true;
            this.$nextTick(() => {
                if (this.$refs.instructionContent) {
                    this.$refs.instructionContent.scrollTop = 0
                }
            })
        },
        getDocumentCategorySet() {
            this.$Progress.start()
            axios.get('/drs/document-template-prompt/category-set', { validateStatus: () => true })
                .then(response => {
                    if (response.status == 200) {
                        this.dtcs_lists = []
                        for (let i = 0; i < response.data.data.length; i++) {
                            const item = response.data.data[i];
                            let row = {
                                id: item.id,
                                name: item.name,
                            }
                            this.dtcs_lists.push(row)
                        }
                        this.$Progress.finish()
                    }
                })
        },
        getAttachmentChecklist(dtcs){
            this.$Progress.start()
            this.dtcsac_id = null;
            axios.get('/drs/document-template-prompt/attachment-checklist/' + dtcs.id, { validateStatus: () => true })
                .then(response => {
                    if (response.status == 200) {
                        this.dtcsac_lists = []
                        for (let i = 0; i < response.data.data.length; i++) {
                            const item = response.data.data[i];
                            let row = {
                                id: item.id,
                                name: item.name,
                            }
                            this.dtcsac_lists.push(row)
                        }
                        this.$Progress.finish()
                    }
                })
        },
        getAIModels: function () {
            this.$Progress.start()
            axios.get('/drs/ai-model/list', {validateStatus: () => true})
            .then(response => {
                if(response.status == 200) {
                    this.ai_model_options = []
                    for (let i = 0; i < response.data.data.length; i++) {
                        const item = response.data.data[i];
                        let row = {
                            id: item.id,
                            label: item.name,
                            name: item.name,
                            provider: item.provider,
                            deleted_at: item.deleted_at,
                            created_at: this.changeDateFormatV2(item.created_at),
                            updated_at: this.changeDateFormat(item.updated_at)
                        }
                        
                        this.ai_model_options.push(row)
                    }
                    this.$Progress.finish()
                }
            })
        },
        getAlreadyPairedTargetNames: function (excludeItemName = null) {
            return this.template_prompt.prompt_items
                .filter(item => item.name !== excludeItemName)
                .map(item => item.paired_prompt_item_name)
                .filter(name => !!name);
        },
        openAddPromptModal() {
            this.selected_paired_prompt_item = 'None';
            this.refreshDropdownOptions();
            this.add_prompt_items_modal = true;
        },
        closeAddPromptModal() {
            this.add_prompt_items_modal = false;
            this.add_prompt_item_extraction_collapse = false;
            this.add_prompt_item_comparison_collapse = false;
            this.resetPromptItems(); 
        },
        closeEditPromptModal() {
            this.edit_prompt_modal = false;
            this.edit_prompt_item_extraction_collapse = false;
            this.edit_prompt_item_comparison_collapse = false;
            this.selected_edit_cross_prompt = 'None';
            this.selected_edit_cross_prompt_item = 'None';
            this.is_edit_main_file_checked = false;
        },
        getCrossPromptOptions: function () {
            this.$Progress.start()
            axios.get('/drs/document-template-prompt/active-list', { validateStatus: () => true })
                .then(response => {
                    if (response.status == 200) {
                        this.cross_prompt_options = [{ label: 'None', value: null }];
                        for (let i = 0; i < response.data.data.length; i++) {
                            const item = response.data.data[i];
                            if (item.id == this.$route.params.id) continue; // NEW - exclude self
                            let row = {
                                label: item.name,
                                value: item.id,
                            }
                            this.cross_prompt_options.push(row)
                        }
                        this.$Progress.finish()
                    }
                })
        },
        getCrossPromptItems: function (promptId, target, preselectItemId = null) {
            this.$Progress.start()
            axios.get('/drs/document-template-prompt/' + promptId, { validateStatus: () => true })
                .then(response => {
                    if (response.status == 200) {
                        const options = [{ label: 'None', value: null }];
                        const items = response.data.data.document_template_prompt_items || [];

                        for (let i = 0; i < items.length; i++) {
                            const item = items[i];
                            if (item.deleted_at == null) {
                                options.push({
                                    label: item.name,
                                    value: item.id,
                                });
                            }
                        }

                        if (target === 'add') {
                            this.cross_prompt_item_options = options;
                        } else {
                            this.edit_cross_prompt_item_options = options;
                            if (preselectItemId) {
                                const match = options.find(o => o.value == preselectItemId);
                                this.selected_edit_cross_prompt_item = match || 'None';
                            }
                        }
                        this.$Progress.finish()
                    }
                })
        },
        onAddCrossPromptChange(newVal) {
            this.prompt_items.cross_prompt_item_id = null;
            this.cross_prompt_item_options = [{ label: 'None', value: null }];
            this.selected_cross_prompt_item = 'None';
            if (newVal?.value) {
                this.getCrossPromptItems(newVal.value, 'add');
            }
        },
        onEditCrossPromptChange(newVal) {
            if (this._suppressEditCrossReset) return;
            this.edit_prompt.cross_prompt_item_id = null;
            this.edit_cross_prompt_item_options = [{ label: 'None', value: null }];
            this.selected_edit_cross_prompt_item = 'None';
            if (newVal?.value) {
                this.getCrossPromptItems(newVal.value, 'edit');
            }
        },
        onMainFileCheckboxChange(checked) {
            if (!checked) {
                this.prompt_items.is_internal_attachment_main_file = 0;
                this.is_main_file_checked = false;
                return;
            }

            const existingMainFileItem = this.template_prompt.prompt_items.find(
                item => item.is_internal_attachment_main_file == 1 && item.deleted_at == null
            );

            if (existingMainFileItem) {
                this.$swal({
                    icon: "warning",
                    title: "Replace main file?",
                    html: `<b>${existingMainFileItem.name}</b> is currently set as the main file. Setting this item instead will unmark it.`,
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, replace it",
                }).then((result) => {
                    if (result.value) {
                        this.prompt_items.is_internal_attachment_main_file = 1;
                        this.is_main_file_checked = true;
                    } else {
                        this.prompt_items.is_internal_attachment_main_file = 0;
                        this.is_main_file_checked = false;
                    }
                });
            } else {
                this.prompt_items.is_internal_attachment_main_file = 1;
                this.is_main_file_checked = true;
            }
        },
        onEditMainFileCheckboxChange(checked) {
            if (!checked) {
                this.edit_prompt.is_internal_attachment_main_file = 0;
                this.is_edit_main_file_checked = false;
                return;
            }

            const existingMainFileItem = this.template_prompt.prompt_items.find(
                (item, idx) => idx !== this.edit_prompt_index &&
                    item.is_internal_attachment_main_file == 1 &&
                    item.deleted_at == null
            );

            if (existingMainFileItem) {
                this.$swal({
                    icon: "warning",
                    title: "Replace main file?",
                    html: `<b>${existingMainFileItem.name}</b> is currently set as the main file. Setting this item instead will unmark it.`,
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, replace it",
                }).then((result) => {
                    if (result.value) {
                        this.edit_prompt.is_internal_attachment_main_file = 1;
                        this.is_edit_main_file_checked = true;
                    } else {
                        this.edit_prompt.is_internal_attachment_main_file = 0;
                        this.is_edit_main_file_checked = false;
                    }
                });
            } else {
                this.edit_prompt.is_internal_attachment_main_file = 1;
                this.is_edit_main_file_checked = true;
            }
        },
    }
}
</script>

<style></style>